import axios from 'axios'

export default {
    getAll: () => axios.get('/promo_code'),
    getById: id => axios.get(`/promo_code/${id}`),
    generateName: () => axios.put(`/promo_code/generate`),
    create: formData => axios.post(`/promo_code/create`, formData),
    changeStatus: formData => axios.patch(`/promo_code/toggle_status`, formData),
    delete: id => axios.delete(`/promo_code/delete/${id}`)
}
